module.exports = __webpack_public_path__ + "static/media/logo-9@2x.004e11ee.png";